<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import DataView from '@/domains/investor/components/DataView/DataView.vue'
import { useGeneralMeetingDataView } from '@/domains/investor/general-meeting/composables/useGeneralMeetingDataView'
import { GENERAL_MEETING_CATEGORIES_SCOPE } from '@/domains/investor/general-meeting/const/generalMeeting.const'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorGeneralMeeting.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorGeneralMeeting.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorGeneralMeeting.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorGeneralMeeting.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorGeneralMeeting.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorGeneralMeeting.canonical.pl'),
    },
  ],
}))

const {
  secondCategory,
  months,
  year,
  page,
  itemsPerPage,
  filters,
  clearFilters,
  onSearch,
  filterOptions,
  generalMeetings,
  generalMeetingColumns,
  total,
  isLoading,
  hasActiveFilters,
  filterLabels,
  headerConfig,
} = await useGeneralMeetingDataView({
  categoryScope: GENERAL_MEETING_CATEGORIES_SCOPE,
})

const generalMeetingsFilters = computed(() => ({
  models: {
    secondCategory,
    year,
    months,
  },
  filters,
  clearFilters,
  showSearch: false,
  showMonths: false,
  showCategory: true,
  showYear: true,
  filterOptions: filterOptions.value,
  hasActiveFilters: hasActiveFilters.value,
  onSearch,
  labels: filterLabels,
}))
</script>

<template>
  <div>
    <InvestorHero
      :title="$t('investor.generalMeeting.hero.title')"
      :lead="$t('investor.generalMeeting.hero.lead')"
      image="/images/investor/hero/general-meeting.png"
      :first-button="{
        text: $t('investor.generalMeeting.hero.firstButton.label'),
        to: $t('investor.generalMeeting.hero.firstButton.to'),
      }"
    />
    
    <DataView
      v-model:page="page"
      :table-items="generalMeetings"
      :table-columns="generalMeetingColumns"
      :total="total"
      :table-filters="generalMeetingsFilters"
      :header="headerConfig"
      :items-per-page="itemsPerPage"
      :show-pagination="true"
      :is-loading="isLoading"
      :empty-state-message="$t('common.dataView.empty')"
      :section-id="$t('investor.generalMeeting.dataView.id')"
    />
  </div>
</template>
